import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Layout from './components/Layout';
import Header from './components/Header';
import './styles/App.css';
// Floating WhatsApp Icon (overlap, fixed on all screens)
const whatsappNumber = '9789703090';
const whatsappLink = `https://wa.me/91${whatsappNumber}`;

const FloatingWhatsApp = () => (
  <a
    href={whatsappLink}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      zIndex: 9999,
      background: '#25D366',
      borderRadius: '50%',
      width: 60,
      height: 60,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 16px #0003',
      cursor: 'pointer',
      transition: 'transform 0.2s',
    }}
    aria-label="Chat on WhatsApp"
  >
      {/* Larger, bold WhatsApp icon with clear call symbol */}
      <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="27" cy="27" r="27" fill="#25D366"/>
        <path d="M27 13C19.268 13 13 19.045 13 26.5c0 2.4.7 4.7 1.9 6.7l-1.4 5.1c-.2.7.5 1.4 1.2 1.2l5.1-1.4c2 1.1 4.3 1.7 6.7 1.7 7.732 0 14-6.045 14-13.5S34.732 13 27 13zm0 24c-2.1 0-4.1-.5-5.9-1.5l-.4-.2-3.1.8.8-3.1-.2-.4C16.5 30.6 16 28.6 16 26.5c0-6.9 6-12.5 13.5-12.5S43 19.6 43 26.5 37 38 29.5 38zm7.1-9.6c-.3-.2-1.5-.7-1.7-.8-.2-.1-.4-.2-.6.1-.2.3-.6 1-1 1.3-.2.2-.4.3-.7.2-.3-.1-1.1-.4-2.1-1.3-.8-.7-1.4-1.5-1.6-1.8-.2-.3 0-.5.2-.7.2-.2.3-.3.5-.5.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.2-.5-1.1-.7-1.6-.2-.5-.5-.4-.7-.4-.2 0-.3 0-.5 0-.2 0-.4.1-.5.2-.2.1-.7.7-.7 1.5 0 .8.5 1.5.6 1.6.1.1 1.3 2.1 3.1 2.8.8.3 1.2.4 1.5.4.6 0 1-.3 1.1-.7.1-.4.1-.6.1-.7 0-.1-.2-.3-.4-.4z" fill="#fff"/>
        <path d="M27 21c-3.3 0-6 2.7-6 6 0 1.1.3 2.1.9 3l.7 1.1-1.1 3.9 3.9-1.1 1.1.7c.9.6 1.9.9 3 .9 3.3 0 6-2.7 6-6s-2.7-6-6-6zm2.7 7.7c-.2.4-.7.7-1.1.7-.2 0-.4 0-.6-.1-.7-.2-2.2-.9-3.2-2.7-.3-.5-.3-.9-.2-1.2.1-.3.3-.5.5-.7.2-.2.4-.3.7-.2.3.1.5.3.6.6.1.2.1.4 0 .6-.1.2-.2.4-.3.5-.1.1-.2.2-.3.3-.1.1-.1.3 0 .4.2.3.7.8 1.2 1.1.2.1.4.1.6 0 .2-.1.4-.3.5-.5.1-.2.3-.3.5-.3.3-.1.6.1.7.4.1.3.1.7-.1 1.1z" fill="#fff"/>
      </svg>
  </a>
);


function App() {
  const [isHeaderHidden, setIsHeaderHidden] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    // Sync cart count with localStorage
    const updateCartCount = () => {
      const storedCart = JSON.parse(localStorage.getItem('cartProducts') || '[]');
      setCartCount(storedCart.length);
    };
    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    return () => window.removeEventListener('storage', updateCartCount);
  }, []);

  return (
    <Router>
      <div className="App">
        <Header isHidden={isHeaderHidden} cartCount={cartCount} />
        <Layout onScroll={setIsHeaderHidden} />
        <FloatingWhatsApp />
      </div>
    </Router>
  );
}

export default App;